export default class DynamicCollectionsList {
  constructor(section) {
    this.el = section.el;
    this.$el = $(this.el);
    this.initializedClass = 'collection-initialized';
    this.$collectionsContainer = $('[data-collections]', this.$el);
    this.collectionHeight = this.el.querySelector('.home-collections').getBoundingClientRect().height;
    this._bindEvents();
    this._setupCollections();
  }

  onSectionLoad() {
    this._bindEvents();
    this._setupCollections();
  }

  onSectionUnload() {
    this._unbindEvents();
  }

  onSectionBlockSelect(event) {
    this._setupCollections();
  }

  onSectionBlockDeselect(event) {
    this._setupCollections();
  }

  _bindEvents() {
    $('.home-collection-overlay-wrapper').on('click', event => this._redirectCollection);
    $(window).on('resize.collections-view', () => {
      this._setupCollections();

      if (!Modernizr.csstransforms) {
        this._centerCollectionText();
      }
    });
  }

  _unbindEvents() {
    $('.home-collection-overlay-wrapper').off('click');
    $(window).off('resize.collections-view');
  }

  _setupCollections() {
    const featuredCollectionImages = this.el.querySelectorAll('.home-collection-image img, .home-collection-image svg');

    $.each(featuredCollectionImages, (index, collectionImage) => {
      $(collectionImage).css({ height: 'auto' });

      const collectionImageHeight = collectionImage.getBoundingClientRect().height;

      if (collectionImageHeight < this.collectionHeight) {
        if (collectionImageHeight > 0) {
          this.collectionHeight = collectionImage.getBoundingClientRect().height;
        }
      }
    });

    $(featuredCollectionImages).css({ height: '' });
    this.$el.find('.home-collection-image').height(this.collectionHeight);
  }

  _centerCollectionText() {
    const collectionText = $('.home-collection-overlay', this.$collectionsContainer);
    for (let i = 0; i < collectionText.length; i++) {
      const collectionTextEl = $(collectionText[i]);
      const textHeight = collectionTextEl.height();
      const textWidth = collectionTextEl.outerWidth();
      collectionTextEl.css({
        marginTop: -(textHeight / 2),
        marginLeft: -(textWidth / 2),
      });
    }
  }

  _redirectCollection(e) {
    const $currentTarget = $(e.currentTarget);

    if (!$currentTarget.parents(this.$collectionsContainer).length) return;

    const url = $currentTarget.data('url');

    if (url !== '') {
      window.location = url;
    }
  }
}
